module.exports = __webpack_public_path__ + "img/FaceRetouchingNaturalOutlined.f855e49f.svg";